import { useState } from 'react'
import { mutate } from '@/runtime'
import type { PageResource } from '@/kinds/page/apply'

/** Editable title; local state so keystrokes never wait on the store, written on blur/Enter. */
export const TitleInput = ({ page }: { page: PageResource }) => {
  // remounted by the parent (key) whenever the stored title changes, so no effect is needed
  const [title, setTitle] = useState(page.spec.title)
  const commit = () => {
    const t = title.trim()
    if (t !== page.spec.title) void mutate.patch(page.id, { spec: { title: t } })
  }
  return (
    <input
      value={title}
      onChange={(e) => setTitle(e.target.value)}
      onBlur={commit}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault()
          ;(e.target as HTMLInputElement).blur()
        }
      }}
      placeholder="Untitled"
      aria-label="Page title"
      className="title-input w-full min-w-0 text-3xl md:text-4xl font-bold tracking-tight leading-tight placeholder:text-faint"
      data-testid="page-title"
    />
  )
}
